import { render, staticRenderFns } from "./THeader.vue?vue&type=template&id=b5855cac&scoped=true&"
import script from "./THeader.vue?vue&type=script&lang=js&"
export * from "./THeader.vue?vue&type=script&lang=js&"
import style0 from "./THeader.vue?vue&type=style&index=0&id=b5855cac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5855cac",
  null
  
)

export default component.exports